import { FC } from "react";
import { Box, Flex } from "@chakra-ui/react";
import { FloatingPhone, IPadFrame, PanelMock } from "../HomeView/components/HomeSections";

const iPhoneScreen = {
  card: {
    title: "Budżet obywatelski 2026",
    rows: [
      { label: "Za", pct: 68, color: "#7c4dff" },
      { label: "Przeciw", pct: 32, color: "rgba(255,255,255,0.4)" }
    ]
  },
  donut: { pct: 72, label: "Frekwencja", sub: "1 240 głosów", color: "#7c4dff" },
  stats: ["Kończy się za 2 dni", "Zakotwiczone on-chain"] as [string, string],
  cta: "Zagłosuj"
};

const androidScreen = {
  card: {
    title: "Zarząd wspólnoty — wybór",
    rows: [
      { label: "Kandydat A", pct: 54, color: "#2fce25" },
      { label: "Kandydat B", pct: 46, color: "rgba(255,255,255,0.4)" }
    ]
  },
  donut: { pct: 61, label: "Frekwencja", sub: "860 głosów", color: "#2fce25" },
  stats: ["Tajne i weryfikowalne", "Push o wyniku"] as [string, string],
  cta: "Oddaj głos"
};

// Klaster urządzeń na slajd „To działa": prawdziwy tablet (panel) + dwa nachodzące telefony — 1:1 ze strony głównej.
export const DeviceCluster: FC = () => (
  <Box position="absolute" inset={0} display="flex" alignItems="center" justifyContent="center" overflow="visible">
    <Box position="relative" w="600px" h="470px" transform="scale(0.72)" transformOrigin="center">
      {/* tablet / panel po zalogowaniu */}
      <IPadFrame position="absolute" left="0" top="6px" w="600px" h="424px">
        <PanelMock />
      </IPadFrame>

      {/* dwa nachodzące telefony (iPhone + Android), wystające zza prawego-dolnego rogu tabletu */}
      <Box position="absolute" right="-86px" bottom="-78px" zIndex={5} transform="scale(0.64)" transformOrigin="bottom right">
        <Flex justify="center" align="center">
          <FloatingPhone
            imageUrl={null}
            alt="Aplikacja na iPhone"
            transform={{ md: "rotate(-8deg) translateX(36px)" }}
            zIndex={1}
            duration="6s"
            delay="0s"
            screen={iPhoneScreen}
          />
          <FloatingPhone
            imageUrl={null}
            alt="Aplikacja na Androida"
            transform={{ md: "rotate(7deg) translateX(-36px)" }}
            zIndex={2}
            duration="6.6s"
            delay="0.9s"
            bgGradient="linear(160deg, #2d0066, #430098)"
            screen={androidScreen}
          />
        </Flex>
      </Box>
    </Box>
  </Box>
);

export default DeviceCluster;
